import React from "react";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import { useNavigate, useOutletContext } from "react-router-dom";
import { isCheckActionsPermission } from "src/helpers/userAccessFun";
import { UserModuleActionTypes, UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";

type Props = {
  columns: columnTypes[];
  rows: any[];
  isLoading:boolean ;
};

const BatchesListing = ({ columns, rows ,isLoading }: Props) => {
  const navigate = useNavigate();
  const [{ formikProps }]: any = useOutletContext();
  const { values } = formikProps;
  return (
    <div className="flex flex-col h-full">
      {/* Page Header */}
      <div className="py-4">
        <ATMPageHeader
          pageTitle="Batches"
          hideAddButton={!isCheckActionsPermission({
            moduleName: UserModuleNameTypes.BATCHES,
            actionName: UserModuleActionTypes.ADD,
          })}
          buttonProps={{
            btnName: "Assign Batch",
            onClick: () => {
              navigate("assign-batch", {
                state: {
                  studenName: values?.name,
                  mobile: values?.mobile,
                },
              });
            },
          }}
          hideSearchBox
        />
      </div>

      {/* Table */}
      <div className="flex-1 overflow-auto flex flex-col">
        <ATMTable
        isLoading={isLoading}
          columns={columns}
          rows={rows}
          rowExtraClasses={() => "min-h-[40px]"}
        />
      </div>
    </div>
  );
};

export default BatchesListing;
